import React from 'react'
import { Trending } from '../Components/TrendingSlider/Trending';
import { Newlaunch } from '../Components/NewLaunch/Newlaunch';
import Product1 from '../Images/product1.webp'
import Product2 from '../Images/product2.webp'
import Product3 from '../Images/product3.webp'
import AboutPic from '../Images/aboutpic.webp'
import '../Pages/home.css'

export const Home = () => {
  return (
    <div>
      <div className="banner"></div>

      <Newlaunch />


      <div className="productslits">
        <div className="productcontainer">
          <div className="productcard">
            <img src={Product1} alt="" />
            <a href='#'>Duffles </a>
          </div>
          <div className="productcard">
            <img src={Product2} alt="" />
            <a href='#'>Backpacks </a>
          </div>
          <div className="productcard">
            <img src={Product3} alt="" />
            <a href='#'>Luagges </a>
          </div>
        </div>
      </div>

      <Trending />

      <div className="about">
                <img src={AboutPic} alt="" />
                <div className="about-content">
                    <h5>ABOUT US</h5>
                    <h1>Sharing Your Love For <br></br>Travel Since 1974</h1>
                    <p>We like to believe that everyone is born to travel. And we are here to make those journeys easier, simpler and a lot more comfortable.
                        We want to change the way you travel with our modern luggage & backpacks; they are designed for travellers, keeping their every little requirement in mind.
                        At Safari Bags, you will be inspired to see the whole world with ease. After all, we are all <span>#BornToTravel</span></p>
                    <button>Learn More</button>
                </div>
            </div>
 


            <div className="discover">
                <h1>The Brand Today</h1>
                <p>Don't let our youthful look fool you. American Tourister has been around for more than Ninty years!</p>
                <button>Discover</button>
            </div>


            <div className="newsletter">
                <h1>Get the latest news from American Tourister.</h1>
                <div className="news">
                    <input type="text" placeholder='Your Email Address..' />
                    <button>Submit</button>

                </div>

            </div>


    </div>
  )
}
